import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLanguage = 'lt';
  private languageSubject = new BehaviorSubject<string>(this.currentLanguage);

  languageChanged: Observable<string> = this.languageSubject.asObservable();

  constructor(private translate: TranslateService) {}

  setLanguage(language: string) {
    this.currentLanguage = language;
    this.translate.use(language);
    this.languageSubject.next(language);
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  translateText(key: string): string {
    return this.translate.instant(key)
  }

  public translatePavadinimas(pavadinimas: any): string {
    return pavadinimas?.[this.currentLanguage] || pavadinimas?.lt || '';
  }
}
